var MAX_GROUP_LENGTH = 20;

function regionsGroups(regions) {
  if (!regions) {
    return [];
  }

  var groups = regions.reduce(function (acc, curr) {
    var _curr$text;

    var groupId = curr.groupId;

    if (acc.some(function (e) {
      return e.id === groupId;
    })) {
      return acc;
    }

    acc.push({
      id: groupId,
      label: (curr === null || curr === void 0 ? void 0 : (_curr$text = curr.text) === null || _curr$text === void 0 ? void 0 : _curr$text.substring(0, MAX_GROUP_LENGTH)) || groupId
    });
    return acc;
  }, []);
  return groups;
}

export default regionsGroups;